import toastr from "toastr";
const toastrDefaultOptions = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: false,
    positionClass: "toast-bottom-full-width",
    preventDuplicates: false,
    onclick: null,
    showDuration: "300",
    hideDuration: "1000",
    timeOut: "5000",
    extendedTimeOut: "1000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut"
};

const post = {
    getCurrentToken: function () {
        $.ajax({
            type: "GET",
            url: "/getAjaxCurrentToken"
        }).done(function (results) {
            $('meta[name="csrf-token"]').attr("content", results);
        });
    },
    postAjaxData: function (
        url,
        paramList,
        toastCompleteString,
        callBackDone,
        callBackFail,
        callBackAlways,
        async = true
    ) {
        // 現在編集している施設の入れ違いがないよう、施設IDをリクエストに含めて検査する
        if ($("#js-submit-nursery-id").length) {
            paramList.append("verifyNurseryId", $("#js-submit-nursery-id").val());
        }

        $.ajax({
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
            },
            type: "POST",
            url: url,
            dataType: "json",
            data: paramList,
            processData: false,
            contentType: false,
            cache: false,
            async: async
        })
            .done(function (results) {
                // CSRF
                $('meta[name="csrf-token"]').attr("content", results["csrf"]);

                if (typeof callBackDone === "function") {
                    callBackDone(results, paramList);
                }

                if (toastCompleteString !== "") {
                    toastr.options = toastrDefaultOptions;
                    toastr.success(toastCompleteString);
                }
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                // 失敗したときのコールバック
                post.getCurrentToken();

                // エラーが発生。エラー内容を出力する。
                if (jqXHR.status === 500 || jqXHR.status === 404) {
                    toastr.options = toastrDefaultOptions;
                    toastr.error("エラーが発生しました。しばらくお待ち下さい");
                } else if (jqXHR.status === 409) {
                    toastr.options = toastrDefaultOptions;
                    toastr.error("エラーが発生しました。画面を再読み込みしてください");
                }

                if (typeof callBackFail === "function") {
                    callBackFail(jqXHR, textStatus, errorThrown);
                }
            })
            .always(function () {
                // 成否に関わらず実行されるコールバック
                if (typeof callBackAlways === "function") {
                    callBackAlways();
                }
            });
    }
};

window.post = post;
